import styled from 'styled-components';

// 與 EnvLight 同一套深色側欄的視覺：白字、低透明度的框線與底色
export const StyledBackground = styled.div`
    padding: 10px 20px 24px 20px;
    width: 100%;
    color: rgba(255, 255, 255, 0.87);
    font-size: 14px;

    .modes {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
        margin-bottom: 16px;
    }

    .mode {
        height: 36px;
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(255, 255, 255, 0.08);
        color: rgba(255, 255, 255, 0.6);
        font-size: 14px;
        cursor: pointer;
        transition: 0.2s;

        &:hover {
            border-color: rgba(255, 255, 255, 0.6);
            color: rgba(255, 255, 255, 0.87);
        }

        &.active {
            border-color: #ff744e;
            background: rgba(255, 116, 78, 0.16);
            color: #ffffff;
        }
    }

    .hint {
        color: rgba(255, 255, 255, 0.5);
        font-size: 12px;
        line-height: 18px;
        margin-top: 8px;
    }

    .error {
        color: #ff8a80;
        font-size: 12px;
        line-height: 18px;
        margin-top: 8px;
    }

    .label {
        color: rgba(255, 255, 255, 0.6);
        font-size: 12px;
        margin-bottom: 8px;
    }

    .swatches {
        display: grid;
        grid-template-columns: repeat(4, 32px);
        gap: 12px;
        margin-bottom: 16px;
    }

    .swatch {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 1px solid rgba(255, 255, 255, 0.3);
        cursor: pointer;
        padding: 0;
        outline-offset: 2px;

        &.active {
            outline: 2px solid #ff744e;
        }
    }

    .customColor {
        display: flex;
        align-items: center;
        gap: 8px;

        input[type='color'] {
            width: 36px;
            height: 32px;
            padding: 0;
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 4px;
            background: transparent;
            cursor: pointer;
        }

        input[type='text'] {
            width: 110px;
            height: 32px;
            padding: 0 8px;
            border-radius: 4px;
            border: 1px solid rgba(255, 255, 255, 0.3);
            background: rgba(255, 255, 255, 0.08);
            color: #ffffff;
            font-size: 14px;
            text-transform: uppercase;

            &.invalid {
                border-color: #ff8a80;
            }
        }
    }

    .imagePreview {
        width: 100%;
        aspect-ratio: 16 / 9;
        border-radius: 4px;
        border: 1px dashed rgba(255, 255, 255, 0.3);
        background-color: rgba(255, 255, 255, 0.08);
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(255, 255, 255, 0.4);
        font-size: 12px;
        margin-bottom: 12px;
    }

    .uploadButton {
        width: 100%;
        height: 36px;
        border-radius: 4px;
        border: none;
        background: linear-gradient(79.78deg, #ed0973 0%, #ff744e 100%);
        color: #ffffff;
        font-size: 14px;
        cursor: pointer;
    }

    .arNote {
        margin-top: 20px;
        padding-top: 12px;
        border-top: 1px solid rgba(255, 255, 255, 0.12);
    }

    .visuallyHidden {
        position: absolute;
        width: 1px;
        height: 1px;
        overflow: hidden;
        clip: rect(0 0 0 0);
    }
`;
